// extracted by mini-css-extract-plugin
module.exports = {"rightButtons":"ShopButtons_rightButtons__DmprG","saveButton":"ShopButtons_saveButton__MR12-"};